import { useTranslation } from 'react-i18next';
import DashboardLayout from '@/components/feature/DashboardLayout';
import OreeMarketView from '../components/OreeMarketView';
import TradingRdFrame from '../components/TradingRdFrame';

/** Дуальний режим (§6 handoff): прод бачить незмінений legacy. */
function LegacyTradingDam() {
  const { t } = useTranslation();
  return (
    <DashboardLayout>
      <div className="mb-4">
        <h1 className="text-xl font-semibold text-gray-900 dark:text-white">{t('trading_dam_title')}</h1>
        <div className="text-xs text-gray-500 dark:text-gray-400 mt-1">{t('trading_dam_subtitle')}</div>
      </div>
      <OreeMarketView marketFilter="DAM" />
    </DashboardLayout>
  );
}

export default function TradingDamPage() {
  const { t } = useTranslation();
  const isRd = import.meta.env.VITE_REDESIGN === '1';
  if (!isRd) return <LegacyTradingDam />;
  return (
    <TradingRdFrame
      title={t('trading_dam_title')}
      subtitle={t('trading_dam_subtitle')}
      breadcrumb={[t('nav_trade_schedule'), t('nav_trading_dam')]}
      marketFilter="DAM"
    />
  );
}
